import __ from './__';
import add_ids_to_url from './add_ids_to_url';
import adjust_data_tables from './adjust_data_tables';
import ajax_complete_handler from './ajax_complete_handler';
import construct_url from './construct_url';
import convert_callable_strings_to_js from './convert_callable_strings_to_js';
import debounce from './debounce';
import disable_button from './disable_button';
import display_when from './display_when';
import enable_button from './enable_button';
import get_csrf_token from './get_csrf_token';
import get_parameter_by_name from './get_parameter_by_name';
import get_selected_row_ids from './get_selected_row_ids';
import insert_browser_history from './insert_browser_history';
import is_numeric from './is_numeric';
import minify_data from './minify_data';
import process_action_data from './process_action_data';
import process_actions from './process_actions';
import reset_form from './reset_form';
import resizer from './resizer';
import scroll_to_element_by_id from './scroll_to_element_by_id';
import submit_form from './submit_form';
import toggle_button_loading from './toggle_button_loading';
import is_version_greater from './is_version_greater';
import {is_bootstrap_version, is_bootstrap_version_4, is_bootstrap_version_5} from './bootstrap_version';
import { FrameworkDetector, detectFramework, getFrameworkClasses, FRAMEWORK } from './framework-detector';

export default {
    // Helpers
    __,
    debounce,
    isNumeric: is_numeric,
    convertCallableStrings: convert_callable_strings_to_js,

    // Forms
    submitForm: submit_form,
    resetForm: reset_form,
    disableButton: disable_button,
    enableButton: enable_button,
    toggleButtonLoading: toggle_button_loading,
    displayWhen: display_when,

    // AJAX
    ajaxCompleteHandler: ajax_complete_handler,
    getCsrfToken: get_csrf_token,

    // Actions
    processActions: process_actions,
    processActionData: process_action_data,

    // URL
    constructUrl: construct_url,
    getUrlParam: get_parameter_by_name,
    addIdsToUrl: add_ids_to_url,
    insertBrowserHistory: insert_browser_history,

    // DOM
    scrollToElement: scroll_to_element_by_id,
    resizer,

    // Detection
    frameworkDetector: FrameworkDetector,
    detectFramework,
    getFrameworkClasses,
    FRAMEWORK,
    isBootstrapVersion: is_bootstrap_version,
    isBootstrap4: is_bootstrap_version_4,
    isBootstrap5: is_bootstrap_version_5,
    isVersionGreater: is_version_greater,

    // DataTables (kept for backwards compat, also in datatables plugin)
    adjustDataTables: adjust_data_tables,
    minifyData: minify_data,
    getSelectedRowIds: get_selected_row_ids,

    // ===== Backwards compatibility aliases (snake_case) =====
    submit_form,
    reset_form,
    disable_button,
    enable_button,
    toggle_button_loading,
    display_when,
    ajax_complete_handler,
    get_csrf_token,
    process_actions,
    process_action_data,
    construct_url,
    get_parameter_by_name,
    add_ids_to_url,
    insert_browser_history,
    scroll_to_element_by_id,
    is_numeric,
    is_version_greater,
    is_bootstrap_version,
    is_bootstrap_version_4,
    is_bootstrap_version_5,
    convert_callable_strings_to_js,
    adjust_data_tables,
    minify_data,
    get_selected_row_ids,
};
